import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const structureEntries: RawTilesetEntry[] = [
	{
		key: "MossGate",
		sprite: "MossGate.png",
	},
	{
		key: "WoodenDoor",
		animations: [
			{
				loop: true,
				tags: { closed: true },
				frames: [{ filename: "WoodenDoor.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { open: true },
				frames: [{ filename: "WoodenDoor_Open.png", interval: 0 }],
			},
		],
	},
	{
		key: "BlastDoor",
		animations: [
			{
				loop: true,
				tags: { closed: true },
				frames: [{ filename: "BlastDoor.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { open: true },
				frames: [{ filename: "BlastDoor_Open.png", interval: 0 }],
			},
		],
	},
	{
		// Only the E sprite is provided. allowTransform lets the renderer rotate
		// it to N/S/W. Diagonal placements fall back to the unrotated E sprite —
		// add a SlidingDoor_NE.png entry if/when those orientations are needed.
		key: "SlidingDoor",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				frames: [{ filename: "SlidingDoor_E.png", interval: 0 }],
			},
		],
	},
	{
		key: "SlidingGate",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["W"],
				frames: [{ filename: "SlidingGate_E.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["E"],
				horizontalFlip: true,
				frames: [{ filename: "SlidingGate_E.png", interval: 0 }],
			},
		],
	},
	{
		key: "RobotSpawner",
		animations: [
			{
				loop: true,
				tags: { closed: true },
				frames: [{ filename: "RobotSpawn.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { open: true, spawning: true },
				frames: [{ filename: "RobotSpawn_Open.png", interval: 0 }],
			},
		],
	},
	{
		key: "DeskWithMachine",
		animations: [
			{
				height: 2,
				width: 1,
				loop: true,
				frames: [{ filename: "Machine_Table.png", interval: 0 }],
			},
		],
	},
	{
		key: "DeskWithComputer",
		animations: [
			{
				height: 2,
				width: 1,
				loop: true,
				frames: [{ filename: "DeskWithComputer.png", interval: 0 }],
			},
		],
	},
	{
		key: "OfficeChair",
		animations: [
			{
				height: 2,
				loop: true,
				frames: [{ filename: "OfficeChair.png", interval: 0 }],
			},
		],
	},
	{
		key: "MachineConnectedToWall",
		animations: [
			{
				height: 2,
				width: 1,
				loop: true,
				frames: [{ filename: "MachineConnectedToWall.png", interval: 0 }],
			},
		],
	},
	{
		key: "Sign",
		sprite: "Sign_Yellow.png",
	},
	{
		key: "WoodenCabinet",
		sprite: "WoodenCabinet.png",
	},
	{
		key: "WoodenDesk",
		sprite: "WoodenTable.png",
	},
	{
		key: "Sculpture1",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Sculpture1_0.png", interval: 850 },
					{ filename: "Sculpture1_1.png", interval: 550 },
					{ filename: "Sculpture1_2.png", interval: 550 },
					{ filename: "Sculpture1_3.png", interval: 550 },
					{ filename: "Sculpture1_4.png", interval: 550 },
					{ filename: "Sculpture1_3.png", interval: 550 },
					{ filename: "Sculpture1_2.png", interval: 550 },
					{ filename: "Sculpture1_1.png", interval: 550 },
				],
			},
		],
	},
	{
		key: "WoodenShelf",
		sprite: "WoodenShelf.png",
	},
	{
		key: "MachineRack",
		sprite: "MachineRack.png",
	},
	{
		key: "LargeMachine",
		animations: [
			{
				height: 2,
				width: 1,
				loop: true,
				frames: [
					{ filename: "LargeMachineA_0.png", interval: 100 },
					{ filename: "LargeMachineA_1.png", interval: 100 },
					{ filename: "LargeMachineA_2.png", interval: 100 },
					{ filename: "LargeMachineA_3.png", interval: 100 },
					{ filename: "LargeMachineA_4.png", interval: 100 },
					{ filename: "LargeMachineA_5.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "PlasticCabinet",
		sprite: "PlasticCabinet.png",
	},
	{
		key: "MetalDoor",
		sprite: "MetalDoor.png",
	},
	{
		key: "MetalLootBox",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Metalbox_0.png", interval: 2000 },
					{ filename: "Metalbox_1.png", interval: 100 },
					{ filename: "Metalbox_2.png", interval: 100 },
					{ filename: "Metalbox_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "RareItemsLootBox",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Orangebox_0.png", interval: 100 },
					{ filename: "Orangebox_1.png", interval: 100 },
					{ filename: "Orangebox_2.png", interval: 100 },
					{ filename: "Orangebox_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "LootBox",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Smallbox_0.png", interval: 2000 },
					{ filename: "Smallbox_1.png", interval: 100 },
					{ filename: "Smallbox_2.png", interval: 100 },
					{ filename: "Smallbox_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "MedicalLootBox",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Medikit_0.png", interval: 2000 },
					{ filename: "Medikit_1.png", interval: 100 },
					{ filename: "Medikit_2.png", interval: 100 },
					{ filename: "Medikit_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "KeyLootBox",
		sprite: "Key.png",
	},
	{
		key: "PowerPlantKeyCardLootBox",
		sprite: "KeyCard.png",
	},
	{
		key: "BaseKeyCardLootBox",
		sprite: "KeyCard.png",
	},
	{
		key: "NightVisionLootBox",
		sprite: "NightVisionItem.png",
	},
	{
		key: "JetpackLootBox",
		sprite: "Jetpack.png",
	},
];
